import { ConfigInicialPerfil } from "./config-inicial-perfil-de-acesso";

export class ConfigInicialPerfis {
    constructor(
       public perfis: ConfigInicialPerfil[] | null = null,
    ){}
}